/* eslint-disable no-useless-computed-key */
import { useEffect, useState } from "react";
import Header from "../header/Header";
// import ShipmentHeader from "./ShipmentHeader";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Dropdown, Menu, message, Modal, Select, Space, Table } from "antd";
import { deleteDoc, doc, getDoc, serverTimestamp, updateDoc } from "firebase/firestore";
import { PiDotsThreeVerticalBold } from "react-icons/pi";
import { useNavigate } from "react-router";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { db } from "../../config/firebase";
import Download from "../../icons/Downloadicon";
import { getShipments } from "../../lib/quotes";
import ExportCSVPopup from "../ExportCSVPopup"; // Import the popup component
// import { set } from "firebase/database";
import dayjs from "dayjs";
import { Archive, CheckCircle, ChevronDown, Clock, FileText, Loader2, MapPin, Package, Plane, Truck, Warehouse } from "lucide-react";
import { api } from "../../config/api";
import { useMyContext } from "../../context/MyContext";
import { FormatDate } from "../../lib/dateFormat";
import { getAlpha2Code } from "../../lib/helper/countryToAphlaCode";
import { getAdmins, getUser } from "../../lib/user";
import DashboardLayout from "../layout";
import AskForModel from "../shared/askForQuestion";
import InvoiceModal from "../shared/common/invoiceModal";
import Loader from "../shared/loader/loader";
import InvoicePDF from "../shared/pdf/invoicePDF";

const deliveryStatusOptions = [
  { value: "preparing collection", label: "Preparing Collection", icon: Clock },
  { value: "In delivery", label: "In Delivery", icon: Truck },
  { value: "Transit air", label: "Transit Air", icon: Plane },
  { value: "Compliance", label: "Compliance", icon: FileText },
  { value: "Storage", label: "Storage", icon: Archive },
  { value: "Delivered", label: "Delivered", icon: CheckCircle },
  { value: "Final delivery", label: "Final Delivery", icon: MapPin },
  { value: "completed", label: "Completed", icon: CheckCircle },
  { value: "warehouse shipment", label: "Warehouse Shipment", icon: Warehouse },
];

const StatusDropdown = ({ status, onChange, id, loading }) => {
  const [isOpen, setIsOpen] = useState(false);

  const getStatusColor = (statusValue) => {
    const lower = statusValue?.toLowerCase();
    switch (lower) {
      case "in progress":
      case "preparing collection":
        return {
          backgroundColor: '#f3f4f6',
          color: '#374151',
          borderColor: '#d1d5db'
        };
      case "delivered":
      case "completed":
        return {
          backgroundColor: '#dcfce7',
          color: '#166534',
          borderColor: '#86efac'
        };
      case "in delivery":
      case "transit air":
      case "compliance":
      case "warehouse shipment":
      case "storage":
      case "final delivery":
        return {
          backgroundColor: '#dbeafe',
          color: '#1e40af',
          borderColor: '#93c5fd'
        };
      default:
        return {
          backgroundColor: '#f3f4f6',
          color: '#374151',
          borderColor: '#d1d5db'
        };
    }
  };

  const isLoading = loading === id

  const currentStatus = deliveryStatusOptions.find(
    opt => opt.value.toLowerCase() === status?.toLowerCase()
  );
  const CurrentIcon = isLoading ? Loader2 : currentStatus?.icon || Package;

  const statusColors = getStatusColor(status);

  return (
    <div className="relative w-full max-w-xs">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-3 py-2 rounded-lg border-2 transition-all duration-200 flex items-center justify-between gap-2 hover:shadow-md"
        style={{
          backgroundColor: isLoading ? "#fef3c7" : statusColors.backgroundColor,
          color: isLoading ? "#d97706" : statusColors.color,
          borderColor: isLoading ? "#d97706" : statusColors.borderColor
        }}
      >
        <div className="flex items-center gap-2">
          <CurrentIcon className={`${isLoading && 'animate-spin'}`} style={{ width: '16px', height: '16px' }} />
          <span className="text-sm font-medium capitalize truncate">
            {isLoading ? 'Please wait...' : status ? status : "Select Status"}
          </span>
        </div>
        <ChevronDown
          style={{
            width: '16px',
            height: '16px',
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 200ms'
          }}
        />
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute z-20 min-w-[250px] mt-2 bg-white rounded-lg shadow-xl border border-gray-200 max-h-80 overflow-y-auto">
            {deliveryStatusOptions.map((option) => {
              const Icon = option.icon;
              const isSelected = option.value.toLowerCase() === status?.toLowerCase();

              return (
                <button
                  key={option.value}
                  onClick={() => {
                    onChange(id, option.value);
                    setIsOpen(false);
                  }}
                  className={`w-full px-4 py-3 flex items-center gap-3 hover:bg-gray-50 transition-colors 
                    } ${option === deliveryStatusOptions[0] ? 'rounded-t-lg' : ''} ${option === deliveryStatusOptions[deliveryStatusOptions.length - 1] ? 'rounded-b-lg' : ''
                    }`}
                  style={{ backgroundColor: isSelected && '#dbeafe', color: isSelected && '#2563eb' }}
                >
                  {/* <Icon className={`w-4 h-4 ${isSelected ? 'text-blue-600' : 'text-gray-500'}`} /> */}
                  <Icon size={20} />
                  <span className={`text-sm font-medium whitespace-nowrap ${isSelected ? 'text-blue-600' : 'text-gray-700'}`}>
                    {option.label}
                  </span>
                  {isSelected && (
                    <CheckCircle className="w-4 h-4 ml-auto text-blue-600" />
                  )}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

const Index = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [filteredData, setFilteredData] = useState([]);
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [shipmentData, setShipmentData] = useState(null);
  const { user, notifications, token } = useMyContext();
  const [warehouseFilter, setWarehouseFilter] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [loadingId, setLoadingId] = useState(null);

  useEffect(() => {
    const filter = searchParams.get("filter");
    if (filter === "warehouse") {
      setWarehouseFilter(true);
      setSelectedStatus("warehouse shipment");
    }
  }, [searchParams]);

  const shipmentId = searchParams.get("ship");
  // console.log("shipmentId", shipmentId);
  const obj = {
    ative: true,
    content: "My Shipments",
  };
  // const [modalIsOpen, setIsOpen] = useState(false);
  // show edit,del on click
  const [menuVisible, setMenuVisible] = useState(false);
  const [selectId, setSelectId] = useState(shipmentId ? shipmentId : "");
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [quotes, setQuotes] = useState([]);
  const queryClient = useQueryClient();
  // const notifications = queryClient.getQueryData(["notifications"]);

  // show delete modal state
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [isModalOpen, setIsModalOpen] = useState(shipmentId ? true : false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  // for edit and delete functionality
  const handleMenuClick = ({ key }) => {
    if (key === "edit") {
      // Handle the edit action
    } else if (key === "delete") {
      // Handle the delete action

      // console.log(selectId);
      setShowDeleteConfirmationModal(true);
    }
    setMenuVisible(false); // Close the menu after the click
  };
  // close action buttons if click anywhere outside
  useEffect(() => {
    const closeMenuOnOutsideClick = (event) => {
      if (menuVisible) {
        const dropdownContainer = document.querySelector(".ant-dropdown");
        if (dropdownContainer && !dropdownContainer.contains(event.target)) {
          setMenuVisible(false); // Close the menu if the click is outside the dropdown
        }
      }
    };

    document.body.addEventListener("click", closeMenuOnOutsideClick);

    return () => {
      document.body.removeEventListener("click", closeMenuOnOutsideClick);
    };
  }, [menuVisible]);

  const { data: invoices, isLoading } = useQuery(
    ["invoices"],
    async () => {
      if (!token) {
        throw new Error("No token available");
      }
      const res = await api.get("/invoice", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!token && !!user,
    }
  );

  const showModal = (id, quoteNumber) => {
    setSelectId(id);
    setIsModalOpen(true);
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("ship", id);
    if (quoteNumber) {
      searchParams.set("quoteNumber", quoteNumber);
    } else {
      searchParams.delete("quoteNumber");
    }
    navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectId("");
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("ship");
    searchParams.delete("quoteNumber");
    navigate(`${location.pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`, { replace: true });
  };

  const [modalOpen, setModalOpen] = useState(false);

  const showCommentModal = () => {
    setModalOpen(true);
  };

  const handlCommenteOk = () => {
    setModalOpen(false);
  };

  const handleCommentCancel = () => {
    setModalOpen(false);
  };

  const { data: admins } = useQuery(
    ["users"],
    async () => {
      const res = await getAdmins();
      return res;
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  const handleAssignAdmin = async (id, adminId) => {
    try {
      const userDocRef = doc(db, "quotes", id);
      const quoteSnapshot = await getDoc(userDocRef);
      const quoteData = quoteSnapshot.data();

      await updateDoc(userDocRef, {
        assignAdmin: adminId,
      });

      // Find the admin user details from admins data
      const assignedAdmin = admins?.find(admin => admin.name === adminId);
      // console.log(assignedAdmin);

      if (assignedAdmin) {
        // Send notification to the assigned admin
        await api.post("/notifications", {
          userId: assignedAdmin.id,
          role: assignedAdmin.role,
          title: "New Shipment Assigned",
          message: `You have been assigned a new shipment: ${quoteData.quoteNumber}`,
          linkText: "View Shipment",
          link: `/shipments`,
          type: "quote-assigned",
          quoteNumber: quoteData.quoteNumber
        });
      }

      toast.success("Task assigned Successfullly");
      queryClient.invalidateQueries(["quotes"]);
      // window.location.reload();
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Error updating status. Please try again later.");
    }
  };

  // Define a function to get the styles based on the quote status
  const getStatusStyles = (status) => {
    // console.log("status", status);
    switch (status?.toLowerCase()) {
      case "in progress":
        return { borderColor: "grey", backgroundColor: "white", color: "black" };
      case "delivered":
        return { borderColor: "green", backgroundColor: "green" };
      case "canceled":
        return { borderColor: "blue", backgroundColor: "blue" };
      case "preparing collection":
        return { borderColor: "grey", backgroundColor: "white", color: "black" };
      case "in delivery":
        return { borderColor: "blue", backgroundColor: "blue" };
      case "transit air":
        return { borderColor: "blue", backgroundColor: "blue" };
      case "compliance":
        return { borderColor: "blue", backgroundColor: "blue" };
      case "warehouse shipment":
        return { borderColor: "blue", backgroundColor: "blue" };
      case "storage":
        return { borderColor: "blue", backgroundColor: "blue" };
      case "final delivery":
        return { borderColor: "blue", backgroundColor: "blue" };
      case "completed":
        return { borderColor: "green", backgroundColor: "green" };
      default:
        return { borderColor: "#000", backgroundColor: "#fff" }; // Default styles
    }
  };

  // quotes
  // const { data, refetch } = useQuery(
  //   ["quotes"], // Change the key to match the getUsers function
  //   async () => {
  //     const res = await getQuotes();
  //     setQuotes(res);
  //     return res;
  //   },
  //   {
  //     refetchOnWindowFocus: false,
  //   }
  // );

  const { data, isLoading: isLoadingQuotes, refetch } = useQuery(
    ["quotes"],
    async () => {
      const res = await getShipments();
      setQuotes(res);
      return res;
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const shipId = searchParams.get("ship");
    const quoteNumber = searchParams.get("quoteNumber");

    if (shipId) {
      const shipment = data?.find((item) => item.id === shipId);
      if (shipment) {
        setSelectId(shipId);
        setIsModalOpen(true);
      }
    } else {
      setIsModalOpen(false);
      setSelectId("");
    }
  }, [location.search, data]);

  // delete the quotes
  const deleteMutation = useMutation(
    async (id) => {
      if (!id) return;
      try {
        const userRef = doc(db, "quotes", id);
        await deleteDoc(userRef);
        setShowDeleteConfirmationModal(false);
        // toast.success("quotes deleted successfully");
        refetch();
      } catch (error) {
        console.error("Error deleting quotes", error);
        if (error.code === "not-found") {
          // Handle case when the document is not found
          toast.warning("User not found");
        } else {
          // Handle other errors
          toast.error(`Could not delete quotes: ${error.message}`);
        }
      }
    },
    {
      onSuccess: () => {
        message.success("quotes deleted successfully!");
      },
    }
  );

  const handleCommentClick = async (id, quoteNumber) => {
    showModal(id, quoteNumber);
    try {
      await api.put(`/notifications/quotes/${user?.uid}`, {
        role: user.role?.includes("admin") ? "admin" : user?.role,
        quoteNumber: quoteNumber,
      });
      queryClient.invalidateQueries(["notifications"]);
    } catch (error) {
      console.error("Error updating notification:", error);
    }
  };

  const handleEdit = (id) => {
    navigate(`/shipments/${id}`);
  };

  const openInvoiceModal = async (data) => {
    setOpenDropdownIndex(null);
    setShipmentData(data);
    setInvoiceModalOpen(true);
  };

  // Define the updateStatus function
  const handleStatusChange = async (id, newStatus) => {

    try {
      setLoadingId(id);
      const userDocRef = doc(db, "quotes", id);
      const quoteSnapshot = await getDoc(userDocRef);
      const quoteData = quoteSnapshot.data() || {};

      const subStatusMapping = {
        "preparing collection": "Collection",
        "in delivery": "Final Delivery",
        "transit air": "In Transit",
        "compliance": "Compliance",
        "final delivery": "Final Delivery",
        "delivered": "Delivered",
        "completed": "Delivered"
      };

      const updatedOrderDetails = {
        ...(quoteData.orderDetails || {}),
      };

      if (subStatusMapping[newStatus?.toLowerCase()]) {
        updatedOrderDetails.subStatus = subStatusMapping[newStatus?.toLowerCase()];
      }

      const updateData = {
        status: newStatus,
        orderDetails: updatedOrderDetails,
      };

      if (newStatus?.toLowerCase() === "warehouse shipment") {
        updateData.sinceInWarehouse = serverTimestamp();
      }

      await updateDoc(userDocRef, updateData);

      // Send notification to the client
      await api.post("/notifications", {
        title: "Shipment Status Updated",
        message: `Status of '${quoteData.orderNumber || quoteData.quoteNumber}' Shipment changed to '${newStatus}'`,
        linkText: "View Shipment",
        link: `/shipments?ship=${id}`,
        role: "user",
        userId: quoteData.userId,
        quoteNumber: quoteData.quoteNumber,
        type: "shipment-status-update"
      });

      toast.success("Shipment Status Updated Successfully");
      queryClient.invalidateQueries(["quotes"]);
      queryClient.invalidateQueries(["notifications"]);
      refetch();
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Error updating status. Please try again later.");
    } finally {
      setLoadingId(false);
    }
  };
  const handleComplete = async (id) => {
    try {
      const userDocRef = doc(db, "quotes", id);
      const quoteSnapshot = await getDoc(userDocRef);
      const quoteData = quoteSnapshot.data() || {};

      const updatedOrderDetails = {
        ...(quoteData.orderDetails || {}),
        subStatus: "Delivered",
      };

      await updateDoc(userDocRef, {
        status: "completed",
        orderDetails: updatedOrderDetails,
      });

      if (quoteData.userId) {
        await api.post("/notifications", {
          title: "Shipment Status Updated",
          message: `Status of '${quoteData.orderNumber || quoteData.quoteNumber}' Shipment changed to 'Completed'`,
          linkText: "View Shipment",
          link: `/shipments?ship=${id}`,
          role: "user",
          userId: quoteData.userId,
          quoteNumber: quoteData.quoteNumber,
          type: "shipment-status-update"
        }).catch(err => console.error("Notification error:", err));
      }

      toast.success("Shipment Status updated successfully!");
      queryClient.invalidateQueries(["quotes"]);
      queryClient.invalidateQueries(["notifications"]);
      refetch();
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Error updating status. Please try again later.");
    }
  };

  function formatDate(dateString) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    const formattedDate = new Date(dateString).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  }
  const deliveryStatusOptions = [
    "preparing collection",
    "In delivery",
    "Transit air",
    "Compliance",
    "Storage",
    "Delivered",
    "Final delivery",
    "completed",
    "warehouse shipment",
  ];

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  useEffect(() => {
    try {
      if (selectedStatus !== "" || searchQuery !== "" || warehouseFilter) {
        setFilteredData(
          data?.filter((quote) => {
            const matchesSearch = Object.values(quote).some(
              (value) =>
                typeof value === "string" &&
                value.toLowerCase().includes(searchQuery.toLowerCase())
            );
            // const matchesStatus =
            //   selectedStatus === "" ||
            //   quote.status === selectedStatus ||
            //   selectedStatus === "All status";
            // return matchesSearch && matchesStatus;
            const matchesStatus =
              selectedStatus === "" ||
              quote.status === selectedStatus ||
              selectedStatus === "All status";

            const matchesWarehouse =
              !warehouseFilter || quote.status === "warehouse shipment";
            return matchesSearch && matchesStatus && matchesWarehouse;
          })
        );
        setShowLoader(false);

      } else {
        setFilteredData(data); // Set filteredData to data when no filters are applied
        setShowLoader(false);

      }
    } catch (error) {
      console.error("Error in useEffect:", error);
      // Handle the error or provide a default behavior
      // For example, you could set an empty array as quotes or provide a default error message
      setFilteredData([]);
      // Or you can rethrow the error to let it bubble up and be caught by a higher-level error boundary
      // throw error;
      setShowLoader(false);

    }
  }, [data, searchQuery, selectedStatus, warehouseFilter]); // Removed 'filteredData' from dependencies

  // const exportData = async () => {
  //   let dataToExport = [];
  //   data?.forEach((d) => {
  //     let data = {
  //       ["Ship Status"]: d?.status ? d?.status : "-",
  //       ["Order Number"]: d?.orderNumber ? d?.orderNumber : "-",
  //       ["Name"]: d?.name ? d?.name : "-",
  //       ["Address"]: d?.address ? d?.address?.toString() : "-",
  //       ["Order Date"]: d?.creationDate ? formatDate(d?.creationDate) : "-",
  //     };
  //     dataToExport.push(data);
  //   });
  //   const worksheet = xlsx.utils.json_to_sheet(dataToExport);
  //   const workbook = xlsx.utils.book_new();
  //   xlsx.utils.book_append_sheet(workbook, worksheet, "Shipments");
  //   xlsx.writeFile(workbook, `Shipments.xlsx`);
  // };

  const columnsForPageTwo = [
    { label: "Ship Status", field: "status" },
    { label: "Order Number", field: "orderNumber" },
    { label: "Quote Number", field: "quoteNumber" },
    { label: "Name", field: "name" },
    { label: "Ship To", field: "shipTo" },
    { label: "Address", field: "address" },
    { label: "Order Date", field: "orderDetails" },
    { label: "Collection Date", field: "loadAddress_PickUpDate" },
    { label: "Delivery Date", field: "unloadAddress_DeliveryDate" }
  ];

  const handleDownloadInvoice = async (record) => {
    setInvoiceLoading(true);
    const res = await api.get(`/invoice/shipment/${record?.id}`);
    const invoiceData = res.data;
    const invoiceDate = dayjs(invoiceData?.invoiceDate);
    const dueDate = dayjs(invoiceData?.dueDate);
    const paymentWithin = dueDate.diff(invoiceDate, "day");
    const client = await getUser(record?.userId);

    let discount = null;
    if (invoiceData && Object.prototype.hasOwnProperty.call(invoiceData, 'discount')) {
      discount = invoiceData.discount;
    } else if (invoiceData?.discount !== undefined) {
      discount = invoiceData.discount;
    } else {
      discount = record?.discount || record?.tradeOSData?.discount || null;
    }
    const dataToSend = {
      ...invoiceData,
      discount,
      paymentWithin,
      client,
      shipment: {
        ...record,
        discount,
      },
    };

    try {
      const blob = await InvoicePDF(dataToSend);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Invoice_${dataToSend?.invoiceNo}.pdf`;
      link.click();
    } catch (error) {
      console.error("Error generating invoice:", error);
      toast.error("Invoice not downloaded");
    } finally {
      setInvoiceLoading(false);
    }
  };
  // useEffect(() => {

  // }, [data]);

  const columns = [
    {
      title: "Status",
      dataIndex: "status",
      render: (status, record, index) => (
        <td className="p-1">
          {/* <select
            className={`border capitalize rounded-sm text-white p-1 py-1  bg-[#e5edfb] w-48`}
            style={{
              ...getStatusStyles(status),
            }}
            value={status}
            onChange={(e) => handleStatusChange(record.id, e.target.value)}
          >
            <option value="" disabled className="text-black bg-white">
              Select Delivery Status
            </option>
            {deliveryStatusOptions.map((status, index) => (
              <option key={index} value={status} className="text-black bg-white">
                {status}
              </option>
            ))}
          </select> */}
          <StatusDropdown
            status={status}
            onChange={(id, value) => handleStatusChange(id, value)}
            id={record.id}
            loading={loadingId}
          />
        </td>
      ),
    },
    {
      title: "Order Number",
      dataIndex: "orderNumber",
    },
    {
      title: "Quote Number",
      dataIndex: "quoteNumber",
    },
    {
      title: "Company",
      dataIndex: "name",
    },
    {
      title: "Assign Task",
      visible: user?.role === "super admin",
      render: (_, record) => (
        <div className="max-w-[150px]">
          <Select
            id="assignAdmin"
            onChange={(value) => handleAssignAdmin(record.id, value)}
            value={record.assignAdmin || "Not Assign "}
            name="assignAdmin"
            placeholder="Select Admin"
            className="w-full"
            options={admins?.map((user) => ({
              label: user.name,
              value: user.name,
              key: user.id,
            }))}
            notFoundContent="Admin not found"
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            showSearch
          />
        </div>
      ),
    },
    {
      title: "Ship To",
      render: (_, record) =>
        `${getAlpha2Code(record.loadCountry)} - ${getAlpha2Code(
          record.unloadCountry
        )}`,
    },
    {
      title: "Date",
      dataIndex: "shipmentCreatedDate",
      render: (shipmentCreatedDate) => shipmentCreatedDate ? FormatDate(shipmentCreatedDate) : "---",
      sorter: {
        compare: (a, b) => {
          const dateA = a.shipmentCreatedDate ? new Date(a.shipmentCreatedDate) : new Date(0);
          const dateB = b.shipmentCreatedDate ? new Date(b.shipmentCreatedDate) : new Date(0);
          return dateA - dateB;
        },
        multiple: 1
      },
      defaultSortOrder: 'descend'
    },
    {
      title: "Actions",
      render: (_, record, index) => (
        <Dropdown
          overlay={
            <Menu onClick={handleMenuClick}>
              <Menu.Item
                onClick={() => handleComplete(record.id)}
                key="MarkAsComplete"
              >
                <Space>MarkAsComplete</Space>
              </Menu.Item>
              <Menu.Item
                onClick={() => handleEdit(record.id, record.quoteNumber)}
                key="edit"
              >
                <Space>Edit</Space>
              </Menu.Item>
              <Menu.Item onClick={() => openInvoiceModal(record)} key="invoice">
                <Space>Create Invoice</Space>
              </Menu.Item>
              {invoices?.find((e) => e?.shipmentId === record?.id) ? (
                <Menu.Item
                  onClick={() => handleDownloadInvoice(record)}
                  key="download invoice"
                >
                  <Space>
                    {invoiceLoading ? "Downloading..." : "Download Invoice"}
                  </Space>
                </Menu.Item>
              ) : null}

              {user?.role === "editor" ? null : (
                <Menu.Item onClick={() => setSelectId(record.id)} key="delete">
                  <Space>Delete</Space>
                </Menu.Item>
              )}
              <Menu.Item
                key="comment"
                onClick={() => {
                  handleCommentClick(record.id, record.quoteNumber);
                }}
              >
                <Space>Comment</Space>
              </Menu.Item>
            </Menu>
          }
          visible={openDropdownIndex === index}
          trigger={["click"]}
          onVisibleChange={(visible) => {
            setOpenDropdownIndex(visible ? index : null);
          }}
        >
          <Link
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setOpenDropdownIndex(index);
            }}
          >
            <Space className="relative">
              <button className="border relative p-1 rounded-md border-[#053F92]">
                <PiDotsThreeVerticalBold size={20} />
                {notifications?.find(
                  (e) =>
                    e?.quoteNumber === record?.quoteNumber && e?.read === false
                ) ? (
                  <div className="w-2 h-2 absolute -top-[2px] right-0 bg-red-600 rounded-full"></div>
                ) : null}
              </button>
            </Space>
          </Link>
        </Dropdown>
      ),
    },
  ];
  // console.log(selectId)
  return (
    <>
      <Modal
        width={900}
        title="Deliverey Note"
        open={modalOpen}
        onOk={handlCommenteOk}
        centered
        footer={false}
        onCancel={handleCommentCancel}
      >
        <div>
          <div className="grid grid-cols-1 gap-3  md:grid-cols-2">
            <div className="flex flex-col gap-1 py-2">
              <label className="w-full text-sm font-normal " htmlFor="name">
                Processing Status
              </label>
              <input
                type="text"
                className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                id="name"
              />
            </div>
            <div className="flex flex-col gap-1 py-2">
              <label
                className="w-full text-sm font-normal "
                htmlFor="companyname"
              >
                Ship Status
              </label>
              <input
                type="text"
                className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                id="companyname"
              />
            </div>
            <div className="flex flex-col gap-1 py-2">
              <label
                className="w-full text-sm font-normal "
                htmlFor="addressone"
              >
                Order Number
              </label>
              <input
                type="text"
                className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                id="addressone"
              />
            </div>
            <div className="flex flex-col gap-1 py-2">
              <label
                className="w-full text-sm font-normal "
                htmlFor="addresstwo"
              >
                Name
              </label>
              <input
                type="text"
                className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                id="addresstwo"
              />
            </div>
            <div className="flex flex-col gap-1 py-2">
              <label className="w-full text-sm font-normal " htmlFor="country">
                Country
              </label>
              <input
                type="text"
                className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                id="country"
              />
            </div>
            <div className="flex flex-col gap-1 py-2">
              <label className="w-full text-sm font-normal " htmlFor="state">
                Order Date
              </label>
              <input
                type="date"
                className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                id="state"
              />
            </div>
          </div>
        </div>

        <button className="mt-4 w-[130px] text-[#fff] rounded-[8px] h-[40px] bg-[#03336e]">
          Send
        </button>
      </Modal>

      <Modal
        title="Comment for Employee"
        open={isModalOpen}
        onOk={handleOk}
        centered
        footer={false}
        onCancel={handleCancel}
      >
        <textarea className="w-full h-[100px] border border-[gray] p-2 rounded-[8px] focus:outline-none" />

        <button className="mt-4 w-[130px] text-[#fff] rounded-[8px] h-[40px] bg-[#03336e]">
          Save
        </button>
      </Modal>

      <Modal
        title={
          <div className="flex flex-col">
            <span>Comments</span>
            <span className="text-xs opacity-60">
              Order No: {data?.find((e) => e?.id === selectId)?.orderNumber || data?.find((e) => e?.id === selectId)?.quoteNumber}
            </span>
          </div>
        }
        open={isModalOpen}
        centered
        footer={null}
        onOk={handleOk}
        onCancel={handleCancel}
        width={"50%"}
      >
        <AskForModel
          id={selectId}
        />
      </Modal>
      <DashboardLayout>
        <div className="w-full h-full bg-cus-gray">
          <Header title="Shipments" />

          <div className="p-5 bg-[#eaeff6]">
            {/* <ShipmentHeader status={deliveryStatusOptions} /> */}
            <div
              className="p-5 rounded-[10px] bg-[#fff]"
              style={{ border: "1px solid rgba(5, 63, 146, 0.24)" }}
            >
              {/* Parent Flex  */}
              <div className="flex flex-wrap gap-3 w-full justify-between ">
                {/* Export CSV Button  */}
                <div className="flex flex-col gap-3 lg:flex-row">
                  <div>
                    <div className="w-full md:w-auto p-2 flex space-x-2 items-center rounded-[5px] border-2 text-blue border-blue">
                      {/* <Search /> */}
                      <input
                        placeholder="Search here"
                        className="w-full outline-none"
                        type="text"
                        name=""
                        id=""
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{ color: "rgba(24, 24, 35, 0.53)" }}
                      />
                    </div>
                  </div>
                  <div>
                    <button
                      className="w-full md:w-auto flex rounded-[5px] items-center space-x-4 py-2 px-4 border-2 text-blue border-blue "
                      onClick={() => {
                        setWarehouseFilter(!warehouseFilter);
                        setSelectedStatus(
                          warehouseFilter ? "All status" : "warehouse shipment"
                        );
                        if (!warehouseFilter) {
                          setSearchParams({ filter: "warehouse" });
                        } else {
                          setSearchParams({});
                        }
                      }}
                    >
                      <p>Warehouse</p>
                    </button>
                  </div>
                  <div className="flex flex-col gap-1 ">
                    <select
                      className="w-full md:w-[200px] py-[8px] rounded-md outline-none border-2 text-blue border-blue active:outline-none focus:outline-none capitalize text-center"
                      onChange={(e) => { setSelectedStatus(e.target.value); setWarehouseFilter(false); }}
                    >
                      <option value="" disabled selected>
                        Select Delivery Status
                      </option>
                      <option value="All status">All status</option>
                      {deliveryStatusOptions.map((status, index) => (
                        <option key={index} value={status}>
                          {status}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <button
                  className="w-full md:w-auto flex rounded-[5px] items-center space-x-4 py-2 px-4 text-white btnBg"
                  onClick={() => setIsPopupOpen(true)}
                >
                  <Download />
                  <p>Export CSV</p>
                </button>
                {/* Filter Button And Search */}
              </div>
              {isPopupOpen && (
                <ExportCSVPopup
                  closePopup={() => setIsPopupOpen(false)}
                  Data={data}
                  columnsToExport={columnsForPageTwo}
                  exportName="Shipment"
                />
              )}
            </div>

            {/* <Table checkbox={true} headings={['Processing Status', 'Ship Status', 'Order Number', 'Name', 'Country', 'Order Date', 'Action']} /> */}

            <div className="flex items-center justify-between px-0 py-2 mt-4 bg-white rounded-md md:py-4">
              {/* for web */}
              <div className=" w-full">
                {showLoader || isLoadingQuotes ? (
                  <Loader />
                ) : (
                  <Table
                    columns={columns}
                    dataSource={filteredData}
                    size="small"
                    className="table w-full border-0"
                  />
                )}
              </div>

            </div>

          </div>
        </div>
      </DashboardLayout>

      <Modal
        title="Confirm Deletion"
        open={showDeleteConfirmationModal}
        onCancel={() => setShowDeleteConfirmationModal(false)}
        onOk={() => {
          // console.log("DELETE", selectId);
          deleteMutation.mutate(selectId);
        }}
        okText="Yes"
        cancelText="No"
        okButtonProps={{
          style: { backgroundColor: "#D83535", color: "#FFFFFF" },
        }}
      >
        <p>Are you sure you want to delete the selected shipment?</p>
      </Modal>
      {invoiceModalOpen && (
        <InvoiceModal
          setModalOpen={setInvoiceModalOpen}
          modalOpen={invoiceModalOpen}
          shipmentData={shipmentData}
          setShipmentData={setShipmentData}
        />
      )}
    </>
  );
};

export default Index;
